module.exports = __webpack_public_path__ + "1.4.6/img/home-item3.c412bc49.png";